<style lang='sass'>
  .paradeiser
    background-color: transparent !important

    box-shadow: none !important
    i, span
      color: #ffffff
    a:hover
      background: none !important
    
    .paradeiser_icon_canvas 
      padding-top: 10px
    
    .paradeiser_logo 
      max-width: 100px !important
    
    .paradeiser_small_logo 
      max-width: 40px !important
  .opaque-nav
    background-color: #739C3B !important
  .uk-button-primary 
    background-color: #739C3B !important;

  
</style>

<template>
  <div class="uk-padding">

    <nav class="paradeiser opaque-nav">
      
      <a v-link="{ path: '/' }">
        <img src="../assets/images/logo-white.png" alt="Logo" class="paradeiser_logo uk-hidden-small">
        <img src="../assets/images/logo-small-white.png" alt="Logo" class="paradeiser_small_logo uk-visible-small">
      </a>

      <a href="https://kuza.teachable.com" target="_blank">
        <div class="paradeiser_icon_canvas">
          <i class="uk-icon uk-icon-play-circle uk-icon-medium"></i>
        </div>
        <span>Courses</span>
      </a>
      
      <a v-link="{ path: '/farms' }">
        <div class="paradeiser_icon_canvas">
          <i class="uk-icon uk-icon-calendar-check-o uk-icon-medium"></i>
        </div>
        <span>Book a Visit</span>
      </a>
<!--
      <a v-link="{ path: '/starter-kits' }">
        <div class="paradeiser_icon_canvas">
          <i class="uk-icon uk-icon-archive uk-icon-medium"></i>
        </div>
        <span>Starter Kits</span>
      </a>-->

      <!--<a v-link="{ path: '/shop' }">
        <div class="paradeiser_icon_canvas">
          <i class="uk-icon uk-icon-shopping-cart uk-icon-medium"></i>
        </div>
        <span>Farm Inputs</span>
      </a>-->
      
      <div class="paradeiser_dropdown">
        <a href="#paradeiser-more" id="paradeiser-dropdown">
          <div class="paradeiser_icon_canvas">
            <i class="uk-icon uk-icon-bars uk-icon-medium"></i>
          </div>
          <span>More</span>
        </a>
        <ul class="paradeiser_children" id="paradeiser-more">
          <li><a href="https://blog.kuza.io" target="_blank">Blog</a></li>
          <li><a href="#/about">About Us</a></li>
          <li><a href="#/contact">Contact Us</a></li>
          <li id="greybox"><a href="#!"></a></li>
        </ul>
      </div>
      
    </nav>
    
  </div>
</template>

<script>
  $(document).ready(function() {
    // enabling to open the overflow menu as the pure css link
    // would toggle a scroll and therefore hide the menu
    document.getElementById("paradeiser-dropdown").addEventListener("click", function(event) {
      // stopping the scroll
      event.preventDefault();
      // toggling the class
      document.getElementById("paradeiser-more").classList.toggle("open");
    });

    // hide the menu on click onto greybox
    document.getElementById("greybox").addEventListener("click", function(event) {
      // stopping the scroll
      event.preventDefault();
      // toggling the class
      document.getElementById("paradeiser-more").classList.remove("open");
    });

    // enabling headroom
    var myElement = document.querySelector(".paradeiser");
    var headroom = new Headroom(myElement, {
      tolerance: 5,
      onUnpin: function() {
        document.getElementById("paradeiser-more").classList.remove("open");
      }
    });
    headroom.init();
  })
</script>


/** WEBPACK FOOTER **
 ** Nav.vue?51531205
 **/